<template>
  <div id ="app">
    <!-- <auto-logout></auto-logout>
    <div v-if="warningZone">You are still?</div> -->
    <!-- <button @click="handleIcon()">Gerakan Pandai</button> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
   name: 'App',
    data(){
      return{
       
      }
    },

 
 
}
</script>

<style>
  /* .bg{
    width: 100%;
  } */
</style>


